import StateFactory from '@/store/helpers/StateFactory'
import { parsePartnerIdFromPathname } from 'App/Helpers'

/**
 * The module's default state.
 *
 * @author Erik Galloway <egalloway@claruscare.com>
 */
export default function state() {
	const { partner_ids = [] } = StateFactory.getFromStorage('user', {})

	const fallbackPartnerId = partner_ids.length > 0 ? partner_ids[0] : null
	const storedPartnerId = StateFactory.getFromStorage(
		'partner',
		fallbackPartnerId
	)
	const pathnamePartnerId =
		typeof window !== 'undefined'
			? parsePartnerIdFromPathname(window.location.pathname)
			: null

	return {
		ids: [],
		items: {},
		active: pathnamePartnerId ?? storedPartnerId,
		pagination: {
			current_page: 1,
			last_page: 1,
			searchKeyword: '',
			isSearching: false,
		},
	}
}
